


var transcend_items = [];
function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {bubbles: true})

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
    };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        console.log(event);
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');
            this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });
            document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener(
            'click',
            this.hide.bind(this)
        );
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
            });
        }
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}

customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver(entries => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
        this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
        if (this.sliderItemsToShow.length === 0) return;
        this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(new CustomEvent('slideChanged', {
                detail: {
                    currentPage: this.currentPage,
                    currentElement: this.sliderItemsToShow[this.currentPage - 1]
                }
            }));
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0])) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }

        if (this.isSlideVisible(this.sliderLastItem)) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();

        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
        this.autoplaySpeed = this.slider.dataset.speed * 1000;

        this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
        this.addEventListener('mouseover', this.focusInHandling.bind(this));
        this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
        this.addEventListener('focusin', this.focusInHandling.bind(this));
        this.addEventListener('focusout', this.focusOutHandling.bind(this));

        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) return;

        if (isFirstSlide && event.currentTarget.name === 'previous') {
            this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === 'next') {
            this.slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton.removeAttribute('disabled');

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach(link => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
        this.play();
    }

    focusInHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
            this.play();
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
        }
    }

    autoRotateSlides() {
        const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
            const button = item.querySelector('a');
            if (index === this.currentPage - 1) {
                if (button) button.removeAttribute('tabindex');
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex');
            } else {
                if (button) button.setAttribute('tabindex', '-1');
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {bubbles: true}));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                if (source && destination) destination.innerHTML = source.innerHTML;

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

function shareWindow(url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    window.open(url, "NewWindow", params);
}


var pageUrl = encodeURIComponent(document.URL);
var tweet = encodeURIComponent(jQuery("meta[property='og:description']").attr("content"));

jQuery(".share.facebook").on("click", function () {
    url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
    shareWindow(url);
});

jQuery(".share.twitter").on("click", function () {
    url = "https://twitter.com/intent/tweet?url=" + pageUrl + "&text=" + tweet;
    shareWindow(url);
})

function Copy() {
    var dummy = document.createElement('input'),
        text = window.location.href;
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
}


customElements.define('variant-radios', VariantRadios);

$('select').select2({
    selectOnClose: false,
    placeholder: 'Select a Size',
    minimumResultsForSearch: -1
});

$('#variants-color').select2({
    selectOnClose: false,
    placeholder: 'Select a Color',
    minimumResultsForSearch: -1
});

$('#ContactForm-chat').select2({
    selectOnClose: false,
    placeholder: 'What do you want to chat about? *',
    minimumResultsForSearch: -1
});

function formatState(state) {

    var $state = $(
        '<span>' + state.text.replace('TM', '<span class="tm">TM</span>') + '</span>'
    );
    return $state;
};

$('#page_selection').select2({
    selectOnClose: false,
    placeholder: 'Categories',
    minimumResultsForSearch: -1,
    width: '100%',
    templateResult: formatState,
    templateSelection: formatState
});

$('#faq_selection').select2({
    selectOnClose: false,
    placeholder: 'Categories',
    minimumResultsForSearch: -1,
    width: '100%',
    templateResult: formatState,
    templateSelection: formatState
});


$(document).on("click", ".show-share", function () {
    if ($(".social-icon-bubble-container").is(":visible")) {

        $(".social-icon-bubble-container").fadeOut();
    } else {
        $(".social-icon-bubble-container").fadeIn();
    }
});
if ($(".faq-module-section").length > 0) {
    $(".faq-module-section").each(function () {
        $(".faq-module-menu").append("<a href='#" + $(this).find(".faq-module-menu-id").attr("id") + "'>" + $(this).find(".faq-section-title").html() + "</a>");

        $("#faq_selection").append('<option value="#' + $(this).find(".faq-module-menu-id").attr("id") + '">' + $(this).find(".faq-section-title").html() + '</option>');
    })


    $("#faq_selection").trigger('change');
}

$(".faq-item .faq-item-title").on("click", function () {
    let parent = $(this).closest(".faq-item");
    if ($(parent).find(".faq-item-content").css('display') == 'none') {
        $(".faq-item").find(".faq-item-content").slideUp("fast");
        $(".faq-item").find(".caret").removeClass("open");
        $(".faq-item").removeClass("faq-open");
        $(parent).addClass("faq-open");
        $(parent).find(".faq-item-content").slideDown("fast");
        $(parent).find(".caret").addClass("open");
    } else {
        $(parent).removeClass("faq-open");
        $(parent).find(".faq-item-content").slideUp("fast");
        $(parent).find(".caret").removeClass("open");
    }
});

var lastScrollTop = 0;
$(window).scroll(function (event) {
    var st = $(this).scrollTop();
    if (st > lastScrollTop) {
        // downscroll code
    } else {
        // upscroll code
    }
    lastScrollTop = st;
});

if (document.querySelector('#how-it-works') !== null) {
    //document.querySelector('#how-it-works').addEventListener('touchstart', touch_direction, {passive: false});
    //document.querySelector('#how-it-works').addEventListener('touchend', touch_end, {passive: false});
    //document.querySelector('#how-it-works').addEventListener('touchmove', touch_slider, {passive: false});
}


document.addEventListener('mousewheel', body_slider_scroll, {passive: false, capture: true});

function body_slider_scroll(e) {
    if ($(e.target).closest(".how-it-works").length == 0) {
        //$(".shopify-section-header-sticky").removeClass("shopify-section-header-hidden");
    }

}

function add_how_it_works_event() {
    if (document.querySelector('#how-it-works-event') !== null)
        document.querySelector('#how-it-works-event').addEventListener('mousewheel', preventScroll, {passive: false, capture: true});
}

function remove_how_it_works_event() {
    if (document.querySelector('#how-it-works-event') !== null)
        document.querySelector('#how-it-works-event').removeEventListener('mousewheel', preventScroll, {passive: false});
}

window.addEventListener('DOMContentLoaded', (event) => {
    add_how_it_works_event();
});
auto_slider = true;

lastY = 0;
down = false;

var sliding = false;
slide_first = true;
slide_running = false;
interval_auto_slider = null


/*interval_auto_slider = setInterval(how_auto_slider, 10000);*/
function how_auto_slider(){
  
  let mobile = ($(window).width() < 992)
    let down = true;

    let text_direction = (down) ? "100%" : "-100%";
    let wrap_text_direction = (down) ? "-100%" : "100%";

    if (mobile) {
        text_direction = (down) ? "-250%" : "250%";
        wrap_text_direction = (down) ? "250%" : "-250%";
    }

    let current_item = $(".how-list .how_list-item[style*='opacity: 1']");
    let next_item = null;

    if (mobile) {
        if (slide_mobile_wrap(down, text_direction, wrap_text_direction)) {
            return false;
        }
    } else {
        if (slide_wrap(down, text_direction, wrap_text_direction)) {
            return false;
        }
    }

    if (mobile) {
        if (down) {
            let next_item = current_item.next(".how_list-item");
            next_slide_mobile_transform(current_item, next_item, text_direction, wrap_text_direction)
        } else {
            let next_item = current_item.prev(".how_list-item");
            next_slide_mobile_transform(current_item, next_item, text_direction, wrap_text_direction)
        }
    } else {
        if (down) {
            let next_item = current_item.next(".how_list-item");
            next_slide(current_item, next_item, wrap_text_direction, text_direction);
        } else {
            let next_item = current_item.prev(".how_list-item");
            next_slide(current_item, next_item, wrap_text_direction, text_direction);
        }
    }
  
}

function touch_direction(e) {
    lastY = e.changedTouches[0].clientY;
    let first_frame = $(".how-list .how_list-item:first").css('opacity') !== '0';
    let last_frame = $(".how-list .how_list-item:last").css('opacity') !== '0';
    if ((down && last_frame) || (!down && first_frame)) {
        return true;
    } else {
        e.preventDefault();
    }

}

function touch_end(e) {

    if (!sliding) {
        let first_frame = $(".how-list .how_list-item:first").css('opacity') !== '0';
        let last_frame = $(".how-list .how_list-item:last").css('opacity') !== '0';


        if ((down && last_frame) || (!down && first_frame)) {
            //console.log("should exit");
            return true;
        }
        var how_slider_top = $('.how-it-works').offset().top;
        if (down)
            $('html, body').animate({scrollTop: how_slider_top}, 500);
        if (!down)
            $('html, body').animate({scrollTop: how_slider_top - 100}, 500);

        e.preventDefault();
        e.stopPropagation();

        slide_scroll_functions(down);
        return false;
    }

}

function touch_slider(e) {
    console.log("in touch slider");
    let currentY = e.changedTouches[0].clientY;


    down = (Math.sign(currentY - lastY) === -1) ? true : false;
    let first_frame = $(".how-list .how_list-item:first").css('opacity') !== '0';
    let last_frame = $(".how-list .how_list-item:last").css('opacity') !== '0';


    if ((down && last_frame) || (!down && first_frame)) {
        //console.log("should exit");
        return true;
    }

    if (sliding) {
        //console.log("preventing scroll");
        e.preventDefault();
        e.stopPropagation();
        return false;
    } else {
        run = true;
    }
    return true;


}


function how_slider_animate(direction, touch = false) {


    let visible_item = $(".how-list .how_list-item[style*='opacity: 1']");

    let next_item = visible_item.next(".how_list-item");
    let index = next_item.index();


    if (!direction) {
        next_item = visible_item.prev(".how_list-item");
        index = next_item.index();
    }
    let image_item = $(".how_image-list .how_image-list-item")[index];
    let text_direction = (direction) ? "-100%" : "100%";

    if (touch) {
        text_direction = (direction) ? "-250%" : "250%";
    }

    if (direction) {

        $(image_item).prev(".how_image-list-item").animate({position: 'absolute', opacity: 0}, 0);
        $(image_item).animate({opacity: 1, position: 'relative'}, 0);


        if (!touch) {
            visible_item.animate({top: text_direction, opacity: 0}, 0);
            next_item.animate({height: 'auto', top: 0, opacity: 1}, 0, function () {
                let first_frame = $(".how-list .how_list-item:first").css('opacity') !== '0';
                if (first_frame) {
                    $(".how-list").addClass("start");
                } else {
                    $(".how-list").removeClass("start");
                }
                sliding = false;
            });
        } else {

            visible_item.animate({opacity: 0}, {
                step: function (now, fx) {
                    $(this).css('left', text_direction);
                }
            }, 0);
            next_item.animate({opacity: 1}, {
                step: function (now, fx) {
                    $(this).css('left', '50%');
                    let first_frame = $(".how-list .how_list-item:first").css('opacity') !== '0';
                    if (first_frame) {
                        $(".how-list").addClass("start");
                    } else {
                        $(".how-list").removeClass("start");
                    }
                    sliding = false;
                }
            }, 0);
        }
    } else if (!direction) {
        $(image_item).next(".how_image-list-item").animate({position: 'absolute', opacity: 0}, 0);
        $(image_item).animate({opacity: 1, position: 'relative'}, 0);

        if (!touch) {
            visible_item.animate({top: text_direction, opacity: 0}, 0);
            next_item.animate({height: 'auto', top: 0, opacity: 1}, 0, function () {
                let last_frame = $(".how-list .how_list-item:last").css('opacity') !== '0';
                if (last_frame) {
                    $(".how-list").addClass("end");
                } else {
                    $(".how-list").removeClass("end");
                }
                sliding = false;

            });
        } else {
            visible_item.animate({opacity: 0}, {
                step: function (now, fx) {
                    $(this).css('left', text_direction);
                }
            }, 0);
            next_item.animate({opacity: 1}, {
                step: function (now, fx) {
                    $(this).css('left', '50%');
                    let first_frame = $(".how-list .how_list-item:first").css('opacity') !== '0';
                    if (first_frame) {
                        $(".how-list").addClass("start");
                    } else {
                        $(".how-list").removeClass("start");
                    }
                    sliding = false;
                }
            }, 0);
        }


    }


}

let allow_start = false;

function slide_scroll_functions(down, touch = false) {

    if ($(".how-list .how_list-item:last").css('opacity') === '0' || $(".how-list .how_list-item:first").css('opacity') === '0') {
        if (sliding) {
            return false;
        }
        if (slide_first) {
            setInterval(function () {
                slide_first = false;
            }, 300);
            return false;
        }

        sliding = true;
        how_slider_animate(down, touch);

        return false;
    } else {
        allow_start = false
        sliding = false;
        return false;
    }

}

function scroll_event_handler(e) {
    clearInterval(interval_auto_slider);
    interval_auto_slider = null;
    var isTrackpad = false;
    if (e.wheelDeltaY) {
        if (e.wheelDeltaY === /*(e.deltaY * -1) ||*/ e.wheelDeltaY === (e.deltaY * -3)) {
            isTrackpad = true;
        }
    }
    else if (e.deltaMode === 0) {
        isTrackpad = true;
    }
    return isTrackpad ? true : false
}

var top_animating = false;
var slide_visible = false;
var desktop_sliding = false;

function preventScroll(e) {
    clearInterval(interval_auto_slider);
    interval_auto_slider = null;

    $(".how-list .how_list-item").each(function (index) {
        if ($(this).css('opacity') === '1') {
            slide_visible = true;
            return false;
        }
        slide_visible = false;
    });

    if (!slide_visible || top_animating || desktop_sliding) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    }

    let down = (e.deltaY > 0) ? true : false;
    let first_frame = $(".how-list .how_list-item").first().css('opacity') === '1';
    let last_frame = $(".how-list .how_list-item").last().css('opacity') === '1';

    let mobile = ($(window).width() < 992);
	if(mobile)
      return true;
    let text_direction = (down) ? "100%" : "-100%";
    let wrap_text_direction = (down) ? "-100%" : "100%";
    if (mobile) {
        text_direction = (down) ? "-250%" : "250%";
        wrap_text_direction = (down) ? "250%" : "-250%";
    }


    let touch_ready = (e.wheelDeltaY === -1 || e.wheelDeltaY === 1);
    allow_start = (touch_ready) ? false : true;

    if ((scroll_event_handler(e) && allow_start) || !slide_visible) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    }


    if (down) {
        if ($(".how-list .how_list-item:last").css('opacity') !== '0') {
            $(".how_image-list .how_image-list-item").css('opacity', '0');
            $(".how_image-list .how_image-list-item:first").css('opacity', '1');
            $(".how-list .how_list-item").css('opacity', '0').css('top', text_direction);
            $(".how-list .how_list-item:last").css('opacity', '0').css('top', wrap_text_direction);
            setTimeout(function () {
                $(".how-list .how_list-item:first").css('opacity', '1').css('top', 0);
                $(".how-list .how_list-item:last").css('top', text_direction);

            }, 500);
            return false;

        }
    } else if (!down) {
        if ($(".how-list .how_list-item:first").css('opacity') !== '0') {
            $(".how_image-list .how_image-list-item").css('opacity', '0');
            $(".how_image-list .how_image-list-item:last").css('opacity', '1');
            $(".how-list .how_list-item").css('opacity', '0').css('top', text_direction);
            $(".how-list .how_list-item:first").css('opacity', '0').css('top', wrap_text_direction);
            setTimeout(function () {
                $(".how-list .how_list-item:last").css('opacity', '1').css('top', 0);
                $(".how-list .how_list-item:first").css('top', text_direction);

            }, 500);
            return false;

        }
    }


    allow_start = scroll_event_handler(e);

    if (!desktop_sliding) {
        let current_item = $(".how-list .how_list-item[style*='opacity: 1']");

        if (current_item.length === 0) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        }
        if (down) {
            let next_item = current_item.next(".how_list-item");
            next_slide(current_item, next_item, wrap_text_direction, text_direction);
        } else {
            let next_item = current_item.prev(".how_list-item");
            next_slide(current_item, next_item, wrap_text_direction, wrap_text_direction);
        }
    } else {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    }
    /*slide_scroll_functions(down);*/
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
}

function next_slide(current, next, current_direction, direction_offset) {
  console.log("next_slide");
    desktop_sliding = true;
    current.css('opacity', '0').css('top', current_direction);
 
  	let image_item = $(".how_image-list .how_image-list-item")[next.index()];
	$(".how_image-list-item").animate({position: 'absolute', opacity: 0}, 0);
    $(image_item).animate({opacity: 1, position: 'relative'}, 0);
  
    setTimeout(function () {
        next.css('opacity', '1').css('top', 0);
        desktop_sliding = false;
    }, 500);
    return false;


}


function next_slide_mobile(current, next, current_direction, direction_offset) {
   console.log("next_slide_mobile");
    desktop_sliding = true;
    current.css('opacity', '0').css('top', current_direction);

  	let image_item = $(".how_image-list .how_image-list-item")[next.index()];
	$(".how_image-list-item").animate({position: 'absolute', opacity: 0}, 0);
    $(image_item).animate({opacity: 1, position: 'relative'}, 0);
  
    setTimeout(function () {
        next.css('opacity', '1').css('top', 0);
        desktop_sliding = false;
    }, 500);
    return false;


}

function next_slide_mobile_transform(current, next, current_direction, direction_offset) {
    desktop_sliding = true;
  
    let hidden_slides = $('.how-list .how_list-item[style*="opacity: 0"]');
    hidden_slides.css('left', direction_offset );
    current.css('opacity', '0').css('left', current_direction);
  
	let image_item = $(".how_image-list .how_image-list-item")[next.index()];
	$(".how_image-list-item").animate({position: 'absolute', opacity: 0}, 0);
    $(image_item).animate({opacity: 1, position: 'relative'}, 0);
  
    setTimeout(function () {
        next.css('opacity', '1').css('left', '50%');
        desktop_sliding = false;
    }, 500);
    return false;
}

function slide_mobile_wrap(down, current_direction, direction_offset) {
    if (down) {
        if ($(".how-list .how_list-item:last").css('opacity') !== '0') {
            $(".how_image-list .how_image-list-item").css('opacity', '0');
            $(".how_image-list .how_image-list-item:first").css('opacity', '1');
            $(".how-list .how_list-item").not(":last").css('opacity', '0').css('left', direction_offset );
            $(".how-list .how_list-item:last").css('opacity', '0').css('left', current_direction);
          	
            setTimeout(function () {
                $(".how-list .how_list-item:first").css('opacity', '1').css('left', '50%');
            }, 500);
            return true;
        }
    } else if (!down) {
        if ($(".how-list .how_list-item:first").css('opacity') !== '0') {
            $(".how_image-list .how_image-list-item").css('opacity', '0');
            $(".how_image-list .how_image-list-item:last").css('opacity', '1');
            $(".how-list .how_list-item").not(":first").css('opacity', '0').css('left', direction_offset);
            $(".how-list .how_list-item:first").css('opacity', '0').css('left', current_direction);

            setTimeout(function () {
                $(".how-list .how_list-item:last").css('opacity', '1').css('left', '50%');
            }, 500);
            return true;
        }
    }
    return false;
}


function slide_wrap(down, current_direction, direction_offset) {
    if (down) {
        if ($(".how-list .how_list-item:last").css('opacity') !== '0') {
            $(".how_image-list .how_image-list-item").css('opacity', '0');
            $(".how_image-list .how_image-list-item:first").css('opacity', '1');
            $(".how-list .how_list-item").not(":last").css('opacity', '0').css('top', current_direction);
            $(".how-list .how_list-item:last").css('opacity', '0').css('top', direction_offset);
          
            setTimeout(function () {
                $(".how-list .how_list-item:first").css('opacity', '1').css('top', 0);
            }, 500);
            return true;

        }
    } else if (!down) {
        if ($(".how-list .how_list-item:first").css('opacity') !== '0') {
            $(".how_image-list .how_image-list-item").css('opacity', '0');
            $(".how_image-list .how_image-list-item:last").css('opacity', '1');
            $(".how-list .how_list-item").not(":first").css('opacity', '0').css('top', current_direction);
            $(".how-list .how_list-item:first").css('opacity', '0').css('top', direction_offset);
          
            setTimeout(function () {
                $(".how-list .how_list-item:last").css('opacity', '1').css('top', 0);
            }, 500);
            return true;

        }
    }
    return false;
}

$(".skip-section-button-container .next-section").on("click", function (x) {
    let next_section = $(this).closest(".shopify-section").next(".shopify-section");
    var next_section_top = next_section.offset().top;
    $('html, body').animate({scrollTop: next_section_top}, 500);
});
$(".skip-section-button-container .back-section").on("click", function (x) {
    let next_section = $(this).closest(".shopify-section").prev(".shopify-section").prev(".shopify-section");
    var next_section_top = next_section.offset().top - 130;
    $('html, body').animate({scrollTop: next_section_top}, 500);
});


/*
$(window).on("scroll touchmove mousewheel", (function (e) {
    
    var stickySidebar = $('.how-it-works').offset().top;
    if ($(window).scrollTop() >= stickySidebar - 100) {
            if ($(".how-list .how_list-item:last").css('opacity') == '0' ) {
                if(sliding) return true;
              	
                if($("body").css('overflow') !== "hidden")  { 
                  $("body").css("overflow", "hidden");
                }
              if(slide_first){
              setInterval(function() {
                          slide_first = false;
                 }, 1500);
                return true;
              }
               sliding = true;
                let visible_item = $(".how-list .how_list-item[style*='opacity: 1']");
                let next_item = visible_item.next(".how_list-item");
              	let index = next_item.index();
              let image_item = $(".how_image-list .how_image-list-item")[index];
      
              $(image_item).prev(".how_image-list-item").animate({ position:'absolute', opacity: 0 }, 'slow');
              $(image_item).animate({ opacity: 1, position: 'relative' }, 'slow');
              
              visible_item.animate({ top: "-100%", opacity: 0 }, 'slow');
              next_item.animate({ height: 'auto',top:0, opacity: 1 }, 'slow', function(){
                 setInterval(function() {
                          sliding = false;
                      }, 2000);
                    
              });

              

            } else {
                $("body").css("overflow", "");
            }
    }

}));
*/
$(".slider-controls .arrow").on("click", function (e, f) {
    if (typeof f === "undefined") {
        clearInterval(interval_auto_slider);
        interval_auto_slider = null;
    }

    let mobile = ($(window).width() < 992)
    let down = $(this).hasClass("right");

    let text_direction = (down) ? "100%" : "-100%";
    let wrap_text_direction = (down) ? "-100%" : "100%";

    if (mobile) {
        text_direction = (down) ? "-250%" : "250%";
        wrap_text_direction = (down) ? "250%" : "-250%";
    }

    let current_item = $(".how-list .how_list-item[style*='opacity: 1']");
    let next_item = null;

    if (mobile) {
        if (slide_mobile_wrap(down, text_direction, wrap_text_direction)) {
            return false;
        }
    } else {
        if (slide_wrap(down, text_direction, wrap_text_direction)) {
            return false;
        }
    }

    if (mobile) {
        if (down) {
            let next_item = current_item.next(".how_list-item");
            next_slide_mobile_transform(current_item, next_item, text_direction, wrap_text_direction)
        } else {
            let next_item = current_item.prev(".how_list-item");
            next_slide_mobile_transform(current_item, next_item, text_direction, wrap_text_direction)
        }
    } else {
        if (down) {
            let next_item = current_item.next(".how_list-item");
            next_slide(current_item, next_item, wrap_text_direction, text_direction);
        } else {
            let next_item = current_item.prev(".how_list-item");
            next_slide(current_item, next_item, wrap_text_direction, text_direction);
        }
    }


});


let tallest_slide = 0;
$.each($(".how-list .how_list-item"), function () {
    tallest_slide = ($(this).height() > tallest_slide) ? $(this).height() : tallest_slide;
});
$(".how-list").css("height", tallest_slide);


$(window).resize(function() {
  tallest_slide = 0;
  $.each($(".how-list .how_list-item"), function () {
    tallest_slide = ($(this).height() > tallest_slide) ? $(this).height() : tallest_slide;
  });
  $(".how-list").css("height", tallest_slide);
});


$("img, svg").parent('a').addClass("contains-image");
$(document).ready(function () {
    $(".article-content h2").each(function (index) {
        $(this).attr("id", "contents-" + index);
        $(".article-sitemap .site-map").append("<li><img src='https://cdn.shopify.com/s/files/1/0561/7428/0738/t/1/assets/bullet-leaf-dark.png?v=63461480424594251911650034631' width='25' height='22'><div><a href='#contents-" + index + "'>" + $(this).text() + "</a></div></li>");
    });
});

$(".quantity-step").on("click", function () {
    let input = $(this).closest("div").find(".quantity-input");
    if ($(this).hasClass("up")) {
        let quantity = parseInt(input.val()) + 1;
        input.val(quantity);
        $(".update-price").text("$" + parseInt($(this).closest(".quantity-stepper").attr("data-price")) * quantity);
    } else {
        if (input.val() > "1") {
            let quantity = parseInt(input.val()) - 1;
            input.val(quantity);
            $(".update-price").text("$" + parseInt($(this).closest(".quantity-stepper").attr("data-price")) * quantity);
        }
    }
});

$(document).ready(function () {
    $(".fadeIn").css("opacity", "1");
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                $(".close-icon").click();
                var target = $(this.hash);

                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();


                    $('html, body').animate(
                        {
                            scrollTop: target.offset().top - 100 // Scroll to this location.
                        }, {
                            // Set the duration long enough to allow time
                            // to lazy load the elements.
                            duration: 1000,

                            // At each animation step, check whether the target has moved.
                            step: function (now, fx) {

                                // Where is the target now located on the page?
                                // i.e. its location will change as images etc. are lazy loaded
                                var newOffset = target.offset().top - 100;

                                // If where we were originally planning to scroll to is not
                                // the same as the new offset (newOffset) then change where
                                // the animation is scrolling to (fx.end).
                                if (fx.end !== newOffset)
                                    fx.end = newOffset;
                            }
                        }
                    );

                }
            }
        });
});


var slideIndex = 1;
var auto_slide_exit = false;
showSlides(slideIndex);
var interval_slider = null;

if ($(".slideshow-container").length > 0) {
    var current_slide;
    function product_slide_previous(){
      let slide = $(".mySlides:visible").prev(".mySlides");
      if (slide.length > 0) {
            showSlides(slide.index() + 1, true);
        } else {
            showSlides($(".mySlides").length, true);
        }
    }
   function product_slide_next(){
      let slide = $(".mySlides:visible").next(".mySlides");
      if (slide.length > 0) {
            showSlides(slide.index() + 1, true);
        } else {
            showSlides(1, true);
        }
    }
    function auto_slider() {
        if (auto_slide_exit) return false;
        let slide = $(".mySlides:visible").next(".mySlides");

        if (slide.length > 0) {
            showSlides(slide.index() + 1, true);
        } else {
            showSlides(1, true);
        }

    }

    //interval_slider = setInterval(auto_slider, 6000);
}

function showSlide(n, continue_slide = true) {
    clearInterval(interval_slider);
    interval_slider = null;
    showSlides(n, continue_slide);
    //interval_slider = setInterval(auto_slider, 6000);
}

function showSlides(n, continue_slide = true) {


    if (!continue_slide) {
        auto_slide_exit = true;
    }
    var i;
    var slides = document.getElementsByClassName("mySlides");
    if (slides.length <= 0)
        return;
    slideIndex = n;
    let slide_images = $(".thumbnail-container .thumbnail-image");
    slide_images.removeClass("active");
    $(slide_images[slideIndex - 1]).addClass("active");
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }
    slides[slideIndex - 1].style.display = "block";

}


var checkout_page = false;
var remove_item = false;
var add_item_to_cart = false;
var viewing_cart = false;
var change_quantity = "0";
function get_cart_data(open = false, cart_page = false) {
    jQuery.getJSON('/cart.js', function (cartContents, textStatus) { // Get cart items
        $.each(cartContents.items, function (index) {
            cartContents.items[index]['final_line_price'] = Shopify.formatMoney(cartContents.items[index]['final_line_price'])

        })

      if(viewing_cart || cart_page){

        let cart_items = [];
        $.each(cartContents.items, function(index, value){
          cart_items.push({
        item_id: value.product_id,
        item_name: value.product_title,
        currency: "USD",
        item_brand: value.vendor.trim(),

        price: value.price / 100,
        quantity: value.quantity,
            item_variant: (typeof value.variant_title === "undefined")? null : value.variant_title
      })
        })
        add_ga_event_multiple_items("view_cart", cartContents, cart_items);
   
        viewing_cart = false;
      }
      transcend_items = cartContents;
        cartContents.items_subtotal_price = Shopify.formatMoney(cartContents.items_subtotal_price);

        $(".cart-items").empty();
        $(".cart__foot-inner").empty();
        if ($('#drawer-footer').length === 0)
            return false;

        var drawer_footer_html = $('#drawer-footer').html();
        var html = $('#drawer-items').html();

        var drawer_template = Handlebars.compile(drawer_footer_html);
        var template = Handlebars.compile(html);

        var context = cartContents;

        if (context.items.length === 0) {
            $(".cart-items").append('<div class="text-center">' +
                '<p class="cart-dropdown__empty-message" data-empty-message="">Your cart is ready to grow...</p>' +
                '<a href="/" class="btn transparent-btn mt-15 text-center d-inline">Continue Shopping</a>' +
                '</div>');

            $("body").addClass("cart-empty");
        } else {
            $("body").removeClass("cart-empty");
        }
        $(".cart-items").append(template(context));
        $(".cart__foot-inner").append(drawer_template(context));
        $(".cart-count-bubble").text(context.item_count);

        $(".totals__subtotal-value").text(context.items_subtotal_price);
        if (open) {
            $(".cart-dropdown").addClass("is-open");
            $("body").css('overflow', 'hidden');
        }
    });
}
function getSearchParams(k){
 var p={};
 location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(s,k,v){p[k]=v})
 return k?p[k]:p;
}
function get_item_data(url){
  let variant = getSearchParams("variant");

  jQuery.getJSON(url, function (cartContents, textStatus) {

    let selected_variant = $.grep(cartContents.product.variants, function(v) {
              return v.id == variant;
          });


    add_ga_event("remove_from_cart", {
      final_line_price: 0,
      id:cartContents.product.id,
      product_title: cartContents.product.title,
      vendor: cartContents.product.vendor,
      product_type: cartContents.product.product_type,
      price: (selected_variant.length === 0) ? 0 : selected_variant[0].price / 100,
      quantity: 1,
      item_variant: (typeof selected_variant.variant_title === "undefined")? null : selected_variant.variant_title,
    })

  });
}
var add_quanity = false;
function change_cart_data(id, quantity, refresh = true, open = true, url = "") {
    console.log(url.replace("?", ".json?"))
  console.log("Quantity:" + quantity);
    fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
        },
        body: JSON.stringify({"id": id, "quantity": quantity})
    }).then(response => response.json())
        .then(data => {
          var item = $.grep(data.items, function(v) {
              return v.key === id;
          });
          if(quantity > 0 && item.length > 0){
            let action = (add_quanity) ? "add_to_cart" : "remove_from_cart";
              console.log(change_quantity);
             item[0].variant_title = item[0].variant_options[0];

            add_ga_event(action, item[0]);
            
          } else if(quantity === 0) {
            get_item_data(url);
          }
          add_quanity = false;
            if (refresh)
                get_cart_data(open);
        });
}
function add_ga_event_multiple_items(type, data, cart_items){
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: type,
    ecommerce: {
      currency: "USD",
      value: (typeof data.original_total_price !== "undefined")? data.original_total_price / 100 :data.final_line_price / 100,
      items: cart_items
  }
});
};
  
function add_ga_event(type, data){
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  
  if(change_quantity > 0){
  data.quantity = (type === "add_to_cart" || type === "remove_from_cart")? change_quantity : data.quantity;
  data.price = (type === "add_to_cart" || type === "remove_from_cart")? data.original_price * change_quantity : data.price;
  } else {
    data.quantity = (type === "add_to_cart" || type === "remove_from_cart")? 1 : data.quantity;
  data.price = (type === "add_to_cart" || type === "remove_from_cart")? data.original_price : data.price;
  }
  dataLayer.push({
    event: type,
    ecommerce: {
      currency: "USD",
        value: (typeof data.original_total_price !== "undefined")? data.original_total_price / 100 :data.final_line_price / 100,
      items: [
      {
        item_id: (typeof data.product_id ==="undefined") ? data.id : data.product_id,
        item_name: data.product_title,
        currency: "USD",
        item_brand: data.vendor.trim(),
        
        price: data.price / 100,
        quantity: data.quantity,
        item_variant: (typeof data.variant_title === "undefined")? null : data.variant_title
      }
      ]
  }
});
change_quantity = "0";
}

$(document).on("click", ".cart-item__remove", function (x) {
    x.preventDefault();
  remove_item = true;
    change_cart_data($(this).attr("data-id"), 0,true, true, $(this).attr("data-url"));
});

$(document).on("focus", ".cart__quantity-field", function (x) {
  change_quantity = $(this).val();

});

$(document).on("change", ".cart__quantity-field", function (x) {
     add_quanity = !(change_quantity > $(this).val())
   change_quantity = (change_quantity > $(this).val()) ? change_quantity - $(this).val() : $(this).val() - change_quantity;
    change_cart_data($(this).attr("data-id"), $(this).val(),true, true, $(this).attr("data-url"));
});
$(document).on("click", "[data-quantity-button]", function (x) {
    let open_cart = ($(x.target).closest("#main-cart-items").length > 0) ? false : true;
    let quantity_field = $(this).closest(".cart-item").find(".cart__quantity-field");
    let quantity = $(this).hasClass("cart__quantity-minus") ? parseInt(quantity_field.val()) - 1 : parseInt(quantity_field.val()) + 1;
   add_quanity = !$(this).hasClass("cart__quantity-minus");
    quantity_field.val(quantity);
    change_cart_data(quantity_field.attr("data-id"), quantity, true, open_cart, quantity_field.attr("data-url"));
});

$(document).on("click", ".cart-dropdown__close, body:not(.cart-dropdown)", function (e) {
    if ($(e.target).closest(".cart-dropdown").length <= 0 || $(e.target).closest(".cart-dropdown__close").length > 0) {
        $(".cart-dropdown").removeClass("is-open");
        $("body").css('overflow', '');
    }
});
$(document).on("click", "[href='/cart']", function (x) {
    x.preventDefault();
  viewing_cart = true;
    get_cart_data(true);
});

$(document).on("submit", "[action='/cart/add']", function (x) {
  /* add to cart */
    x.preventDefault();
  if($(this).hasClass("zip-validate-form")){
    $(".zip-proccess .submit").click();
    return;
  }
  viewing_cart = true;
    let addToCartForm = this;
  var add_quantity_object = $(addToCartForm).find('[name="quantity"]');
  if(add_quantity_object.length > 0){
    change_quantity = add_quantity_object.val();
  }
  let options = $(addToCartForm).find("select");
  let errors_found = false;
    if (options.length > 0) {
      $.each(options, function(index, value){
         if ($(value).find('option').filter(':selected').val() == "") {
            $(value).closest(".field").find(".select2").addClass("select-error");
            errors_found = true;
        }
      });
       if(errors_found)
         return false;
    }
    let formData = new FormData(addToCartForm);
    fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    }).then((response) => response.json())
.then((data) => {
  
  add_ga_event("add_to_cart", data);

            get_cart_data(true);
});

});
$(".select2").on("click", function () {
    $(this).removeClass("select-error");
});
$(document).on("submit", "[action='/cart/shipping_rates']", function (x) {
    x.preventDefault();

    let formData = new FormData(this);
    fetch('/cart/shipping_rates.js', {
        method: 'POST',
        body: formData
    })
        .then(response => {
            console.log(response);


        });

});
get_cart_data(false, $('body').hasClass("cart-page"));


$(".refer_email").on("change", function () {
    //let form = $(this).closest("form");
    //form.attr("action", "mailto:" + $(this).val());
});
$(document).on('keyup keypress', 'form input[type="text"]', function(e) {

  if(e.which == 13) {
    e.preventDefault();
    return false;
  }
});
$('input').on('beforeItemAdd', function(event) {
    /* Validate url */
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.item)) {
        event.cancel = false;
    } else {
        event.cancel = true;
    }
});
$(".refer-form").on("submit", function (x) {
    x.preventDefault();
	dataLayer.push({event: 'formSubmit', formId: 'ReferForm'});
    var message = ($(this).find("textarea").val() !== "") ? $(this).find("textarea").val() : $(this).find("textarea").attr("placeholder");

    $(this).find("input.referral_email").tagsinput('refresh');
    var referral_emails = $(this).find("input.referral_email[data-role='tagsinput']").tagsinput('items');
    var refer_email = $(this).find(".refer_email").val();
    var source = $(this).attr("data-source");
    var has_errors = false;
  /*
  if(referral_emails.length == 0){
    $(this).find(".field__input.referral_email").closest(".field--with-error").addClass("has-error");
    has_errors = true;
  }*/
  if(!/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(refer_email)){
    $(this).find(".field__input.refer_email").closest(".field--with-error").addClass("has-error");
    has_errors = true;
  }
  if(has_errors)
    return;

  var referrer = source === 'refer' ? 'Referrer' : 'Referrer Pet';
  add_referral(refer_email, "VM8iHT", source, null, null, referrer );
  dataLayer.push({event: 'formSubmit', formId: "refer_email", email: refer_email});
  
  var referee = source === 'refer' ? 'Referee Human' : 'Referee Pet';
  if(referral_emails.length > 0){
  dataLayer.push({event: 'formSubmit', formId: "referee_email ", email: referral_emails});
  }
  $.each(referral_emails, function(index,value){
    add_referral(value, "UxNyms",source, message, refer_email, referee);
  })
  var refer_container = $(this).find(".refer-container");
  refer_container.find(".refer-content-container").hide();
  refer_container.find(".refer-success").show();
});
function add_referral(email, list_id,source = null, welcome_message = null, relation_email = null, profile_property = null){
  
       var settings = {
          "async": true,
          "crossDomain": true,
          "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
          "method": "POST",
          "headers": {
            "content-type": "application/x-www-form-urlencoded",
            "cache-control": "no-cache"
          },
          "data": {
            "g": list_id,
            "$fields": "$source, Shopify Tags, " + profile_property,
            "email": email,
            
            "$source": source,
            "Shopify Tags": ((source == "petrefer") ? "[\"newsletter\", \"pet\"]" : "[\"newsletter\"]")
          }
        }

        if(relation_email !== null){
          settings['data']["$fields"] = "$relation,$welcome,$source, Shopify Tags, " + profile_property;
          settings['data']["$relation"] = relation_email;
          settings['data']["$welcome"] = welcome_message;
        }
        
        settings.data[profile_property] = true;
        
        $.ajax(settings).done(function (response) {
          console.log(response);
        });
}

$(".product-description-container #WaitlistForm").on("submit", function (e) {

    var email = $(this).find("#ContactForm-email").val();
    var source = 'waitlist';
    var has_errors = false;

    var email_form = $(this);
    e.preventDefault();
    e.stopPropagation();

    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (!regex.test($(this).find('[name="contact[email]"]').val())) {
        $(this).find("#mce-error-response").show();
        return false;
    };

    dataLayer.push({event: 'formSubmit', formId: email_form.attr("id"), email: $(this).find('[name="contact[email]"]').val()});
  


       var settings = {
          "async": true,
          "crossDomain": true,
          "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
          "method": "POST",
          "headers": {
            "content-type": "application/x-www-form-urlencoded",
            "cache-control": "no-cache"
          },
          "data": {
            "g": 'VM8iHT',
            "$fields": "$source, Shopify Tags, Waitlist",
            "email": email,
            
            "$source": source,
            "Shopify Tags": "[\"newsletter\"]",
            "Waitlist": "true"
          }
        }
        
        $.ajax(settings).done(function (response) {
          email_form.find("#mce-error-response").hide();
          $(".email-form .email-input-group").hide();
          $(".email-capture-success").css('display', 'flex');
        });
});

$('[type="checkbox"]').iCheck({
    checkboxClass: 'icheckbox_square-green',
    radioClass: 'iradio_square-green'
});
$(".show-menu").on("click", function () {
    //overflow-hidden-tablet
    $("body").addClass("overflow-hidden-tablet");

    $(".menu-drawer-container").attr("open", "");
    $(".menu-drawer-container").addClass("menu-opening");
    //$(".header__icon--menu").click();
});
$(".close-icon").on("click", function () {
    $("body").removeClass("overflow-hidden-tablet");

    $(".menu-drawer-container").removeAttr("open", "");
    $(".menu-drawer-container").removeClass("menu-opening");
    //$(".header__icon--menu").click();
});

$(".email-capture-form").on("submit", function (e) {
    var email_form = $(this);
    e.preventDefault();
    e.stopPropagation();
    let form_value = $(this).serializeArray();

    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (!regex.test($(this).find('[name="contact[email]"]').val())) {
        $(this).find("#mce-error-response").show();
        return false;
    };
  
    if (get_form_value(form_value, "contact[tags]") !== null) {
        form_value = update_form_value(form_value, "form_type", "customer");
        submit_contact_form($(this), form_value);
    }

  dataLayer.push({event: 'formSubmit', formId: email_form.attr("id"), email: $(this).find('[name="contact[email]"]').val()});
  
    email_form.find("#mce-error-response").hide();
    $(".email-capture-form .email-input-group").hide();
    $(".email-capture-success").css('display', 'flex');
  
});

$(".site__password-form").on("submit", function (e) {
    e.preventDefault();

    let form_value = $(this).serializeArray();


    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!regex.test($(this).find('[name="contact[email]"]').val())) {
        $(".email-error").show();
        return false;
    };

    removeItem(form_value, "password");

    form_value = update_form_value(form_value, "form_type", "customer");
    submit_contact_form($(this), form_value, e);

});

var removeItem = function (thisArray, thisName) {
    "use strict";
    $.each(thisArray, function (index, item) {
        if (item.name == thisName) {
            delete thisArray[index];
        }
    });
}

function update_form_value(data, id, value) {
    for (var item in data) {
        if (data[item].name == id) {
            data[item].value = value;
        }
    }
    return data;
}

function get_form_value(data, id) {
    for (var item in data) {
        if (data[item].name == id) {
            return data[item].value;
        }
    }
    return null;
}

function submit_contact_form(form, data, post_form = null) {

    jQuery.ajax({
        type: 'POST',
        url: '/contact',
        data: $.param(data),
        beforeSend: function (x) {
   
            x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        },
        error: function (jqXHR, textStatus, errorThrown) {

            console.log("jqXHR Error:" + JSON.stringify(jqXHR))
        },
        success: function (response, code, error) {
            if (post_form !== null)
                post_form.currentTarget.submit();
        }
    });
}

$("select,textarea,input").on("change", function () {
    $(this).closest(".field").removeClass("has-error");
});
$(".contact-form").on("submit", function (e) {
    e.preventDefault();
    let has_error = false;
    $(this).find("select,textarea,input").each(function () {
        if ($(this).closest(".field").hasClass("field--with-error")) {
            if ($(this).attr("id") === "ContactForm-email") {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if (!regex.test($(this).val())) {
                    $(this).closest(".field").addClass("has-error");
                    has_error = true;
                }
                ;
            }

            if ($(this).attr("id") === "ContactForm-phone") {
                console.log($(this).val());
                var regex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
                if (!regex.test($(this).val())) {
                    $(this).closest(".field").addClass("has-error");
                    has_error = true;
                }
                ;
            }
            if ($(this).attr("type") === "text") {
                if ($(this).val() === "") {
                    $(this).closest(".field").addClass("has-error");
                    has_error = true;
                }
            }
            if ($(this).is("textarea")) {
                if ($(this).val() === "") {
                    $(this).closest(".field").addClass("has-error");
                    has_error = true;
                }
            }
            if ($(this).is("select")) {
                if ($(this).find(":selected").val() === "") {
                    $(this).closest(".field").addClass("has-error");
                    has_error = true;
                }
            }
        }
    });
    if (has_error) {
        var contact_form = $('#ContactForm').offset().top - 130;
        $('html, body').animate({scrollTop: contact_form}, 500);
        return false;
    }
  	dataLayer.push({event: 'formSubmit', formId: "ContactForm"});
    let form_value = $(this).serializeArray();
    submit_contact_form($(this), form_value);

    if (get_form_value(form_value, "contact[tags]") !== null) {
        form_value = update_form_value(form_value, "form_type", "customer");
        submit_contact_form($(this), form_value);
    }
    $(".contact-context").hide();
    $(".contact-form-container").hide();
    $('html, body').animate({scrollTop: 0}, 500);
    $(".show-success").fadeIn();
    var contact_form = $('#ContactForm').offset().top - 130;

});
/*
$(function () {
    var t;
    document.addEventListener('scroll', function (e) {
        $("#shopify-section-header").addClass("animate");
        $("#shopify-section-header").addClass("shopify-seauction-header-hidden");
        clearTimeout(t);
        checkScroll();
    });

    function checkScroll() {
        t = setTimeout(function () {
            if ($("#shopify-section-header").hasClass("shopify-section-header-hidden")) {
                $("#shopify-section-header").removeClass("shopify-section-header-hidden")
            }

        }, 500);
    }
});
*/

$(document).on("click", function () {
    if ($('summary.list-menu__item').attr('aria-expanded') === "true") {
        $(".shopify-section-header-sticky").addClass("menu-expand-logo");

    } else {
        $(".shopify-section-header-sticky").removeClass("menu-expand-logo");

    }
})


$("#page_selection").on("change", function (x) {

    window.location.href = $(this).find("option:selected").val();
});

$("#faq_selection").on("change", function (x) {
    $("a[href='" + $(this).find("option:selected").val() + "']").click();
});

var popupTimer;

function delayPopup(popup) {
    popupTimer = setTimeout(function () {
        $(popup).popup('hide')
    }, 4200);
}

$(document).ready(function () {
    $('.copy-link').click(function () {
        clearTimeout(popupTimer);

        Copy();

        $(this)
            .popup({
                title: 'Successfully copied to clipboard!',
                on: 'manual',
                position: 'bottom center',
                inline: false
            })
            .popup('show');

        // Hide popup after 5 seconds
        //delayPopup(this);


    });

});
window.onpageshow = function (event) {
    if (event.persisted) {
        window.location.reload();
    }
};

let touchstartX = 0
let touchendX = 0

const slider = document.getElementById('product-slider')
if (slider !== null) {
    function handleGesture() {
        if (touchendX < touchstartX) {
            let slide = $(".mySlides:visible").next(".mySlides");

            if (slide.length > 0) {
                showSlide(slide.index() + 1, false);
            } else {
                showSlide(1, true);
            }
        }
        if (touchendX > touchstartX) {
            let slide = $(".mySlides:visible").prev(".mySlides");
            if (slide.length > 0) {
                showSlide(slide.index() + 1, true);
            } else {
                showSlide($(".mySlides").length, true);
            }
        }
    }

    slider.addEventListener('touchstart', e => {
        touchstartX = e.changedTouches[0].screenX
    })

    slider.addEventListener('touchend', e => {
        touchendX = e.changedTouches[0].screenX
        handleGesture()
    })
}


let touchstart_X = 0
let touchend_X = 0
let touchstart_Y = 0
let touchend_Y = 0
const how_it_works_slider = document.getElementById('how-it-works')
if (how_it_works_slider !== null) {
    function handle_how_it_works_Gesture(e) {
        clearInterval(interval_auto_slider);
        interval_auto_slider = null;
        let offset = window.clientX * 0.4;
        let down = (touchend_X < touchstart_X) ? true : false;


        var xDiff = touchstart_X - touchend_X;
        var yDiff = touchstart_Y - touchend_Y;


        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (down) {
                if ($(".how-list .how_list-item:last").css('opacity') == '1') {

                    $(".how_image-list .how_image-list-item").css('opacity', '0');
                    $(".how_image-list .how_image-list-item:first").css('opacity', '1');
                    $(".how-list .how_list-item").css('opacity', '0').css('left', '250%');
                    $(".how-list .how_list-item:last").css('left', '-250%');
                    setTimeout(function () {
                        $(".how-list .how_list-item:first").css('opacity', '1').css('left', '50%');
                    }, 350);
                    return false;
                }
            } else if (!down) {

                if ($(".how-list .how_list-item:first").css('opacity') == '1') {
                    $(".how_image-list .how_image-list-item").css('opacity', '0');
                    $(".how_image-list .how_image-list-item:last").css('opacity', '1');
                    $(".how-list .how_list-item").css('opacity', '0').css('left', '-250%');
                    $(".how-list .how_list-item:first").css('left', '250%');
                    setTimeout(function () {
                        $(".how-list .how_list-item:last").css('opacity', '1').css('left', '50%');
                    }, 350);
                    return false;
                }
            }
        }


        let first_frame = $(".how-list .how_list-item:first").css('opacity') !== '0';
        let last_frame = $(".how-list .how_list-item:last").css('opacity') !== '0';

        if ((down && last_frame) || (!down && first_frame)) {
            //console.log("should exit");
            return true;
        }

        if (touchend_X < touchstart_X - 50) {
            slide_scroll_functions(down, true);
        }
        if (touchend_X > touchstart_X + 50) {
            slide_scroll_functions(down, true);
        }
    }

    how_it_works_slider.addEventListener('touchstart', e => {
        touchstart_Y = e.changedTouches[0].screenY
        touchstart_X = e.changedTouches[0].screenX
    })

    how_it_works_slider.addEventListener('touchend', e => {
        touchend_X = e.changedTouches[0].screenX
        touchend_Y = e.changedTouches[0].screenY
        handle_how_it_works_Gesture(e)
    })
}
$('[name="contact[Phone Number]"]').mask("(999) 999-9999");

$(window).resize(function() {
  if ($(window).width() > 992){
  if($('.sticky-map').css("position") === "fixed"){
  	var sticky_width = $('.article-body').find(".col-lg-3").width();
    $('.sticky-map').css('max-width', sticky_width);
  }
  } else {
    $('.sticky-map').css('top', '0');
    $('.sticky-map').css('max-width', "100%");
    $('.sticky-map').css('position', 'relative');
	$('.sticky-map').css('bottom', "auto");
  }
});
$(document).ready(function () {
    if ($('.sticky-map').length > 0) {
        var stickyTop = $('.sticky-map').offset().top - $('.header-wrapper').height() - 10;
       
        $(window).scroll(function () {
          
          if ($(window).width() < 992){
            	 $('.sticky-map').css('top', '0');
                    $('.sticky-map').css('max-width', "100%");
                    $('.sticky-map').css('position', 'relative');

                    $('.sticky-map').css('bottom', "auto");
            	
                return false;
          }
         	$('.sticky-map').css('display', "block");
 			var sticky_width = $('.article-body').find(".col-lg-3").width();
            var windowTop = $(window).scrollTop();
            var article_bottom = $('.article-body').offset().top + $('.article-body').height();

            console.log(windowTop);
            console.log(stickyTop);
            if (windowTop > (article_bottom - $('.sticky-map').height() - $('.header-wrapper').height() - 10)) {
                $('.sticky-map').css('bottom', 0);
                $('.sticky-map').css('top', "auto");
                $('.sticky-map').css('position', "absolute");
              
            } else {
                if (stickyTop < windowTop) {
                    $('.sticky-map').css('z-index', "1");
                    $('.sticky-map').css('max-width', sticky_width);
                    $('.sticky-map').css('position', 'fixed');
                    $('.sticky-map').css('top', $('.header-wrapper').height() + 10);
                    $('.sticky-map').css('bottom', "auto");
                } else {
                    $('.sticky-map').css('top', '0');
                    $('.sticky-map').css('max-width', "100%");
                    $('.sticky-map').css('position', 'relative');

                    $('.sticky-map').css('bottom', "auto");
                }
            }
        });
     
    }
});
$(document).ready(function () {
var lastPos = 0;
$(".forest-opening-slider .slider-container").scroll(function() {
    var currPos = $(".forest-opening-slider .slider-container").scrollLeft();

    if (lastPos < currPos) {
        $(".slide-dots").addClass("slide-active");
    } 
    if (lastPos > currPos) 
    {
        $(".slide-dots").removeClass("slide-active");
    }
    lastPos = currPos;
});
});
  function submitGoogleForm() {
    try {

      var xhr = new XMLHttpRequest();

      xhr.open('POST', "https://docs.google.com/forms/u/1/d/e/1FAIpQLSdha3LDIwXK3GDQY2T5V1sGJ5hnw8brKu1U0NDusf0p8R7CiA/formResponse", true);
      xhr.setRequestHeader('Accept',
          'application/xml, text/xml, */*; q=0.01');
      xhr.setRequestHeader('Content-type',
          'application/x-www-form-urlencoded; charset=UTF-8');
      xhr.send($.param({"entry.1899618811" : $("[name='Zipcode']").val(), "submit": "Submit"}));
    } catch(e) {

    }
       $(".zip-validation").addClass("error");
                     $(".zip-validation .info-icon").addClass("error");
                     $(".zip-validation .validation-text").text($(".zip-validation .validation-text").attr("data-error-text"));
                    $(".zip-validation").closest("form").find("button").prop("disabled",true);
    return false;
  }
$("[name='Zipcode']").on("focus", function(){$(this).removeClass("select-error")});
$(".zip-proccess .submit").on("click", function(){
  if($("[name='Zipcode']").val() == "" || !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test($("[name='Zipcode']").val())){
    $("[name='Zipcode']").addClass("select-error");
    return;
  }
  submitGoogleForm();
});
$(".refer-modal .modal-close-icon, .refer-modal").on("click", function(x){
  if($(x.target).hasClass("refer-modal") || $(x.target).parent().hasClass("modal-close-icon")){
  $(".refer-modal").fadeOut();
  $("body").removeClass("modal-open");
  }
});
$("[href='#refermodal']").on("click", function(e){
  e.preventDefault();
  $("body").addClass("modal-open");
  $(".refer-modal").css("display", "flex")
    .hide().fadeIn();
});
$( document ).ready(function() {
   // $("#shopify-section-header").height($("sticky-header").height());
//$("sticky-header").addClass("fixed");



$(window).scroll(function(){
  var sticky = $("sticky-header"),
      scroll = $(window).scrollTop();

  if (scroll >= 1) sticky.addClass('shrink');
  else sticky.removeClass('shrink');
});
});

$(".multi__variant-selector").on("change", function(){
  var variants = JSON.parse($("#variant-data").text());

  var selections =  $(".multi__variant-selector option:selected");
  var option1 = $(selections[0]).val();
  var option2 = $(selections[1]).val();

  var selection = variants.find((e) => { return  e.option1 == option1 && e.option2 == option2 });
  var color_selection = variants.find((e) => { return  e.option1 == option1 });
  var size_selections = $.grep(variants, function(element, index) {
    return element.option1 == option1;
});

  if($(this).attr("id") == "variants-color"){
      $("#variants-size").val('').trigger('change');
      $("#variants-size").find("option").prop("disabled", false);
      $.each(size_selections, function(index, value){
        console.log(value.available);
        if(!value.available){
          let option_value =  $("#variants-size").find("option[value='" + value.option2 + "']");
          option_value.prop("disabled", true);
          if(!/\b - SOLD OUT\b/i.test(option_value.text())){
            option_value.text(option_value.text() + " - SOLD OUT");
          }
        } else {
           let option_value =  $("#variants-size").find("option[value='" + value.option2 + "']");
           option_value.text(option_value.text().replace(" - SOLD OUT", ""));
        }
        
      })
    $("#variants-size").select2({
    selectOnClose: false,
    placeholder: 'Select a Size',
    minimumResultsForSearch: -1
});
  }
  if(typeof color_selection !== "undefined"){
    showSlide($("[data-id='" + color_selection.featured_media.id + "']").closest(".mySlides").index() + 1);
  }
  if(typeof selection !== "undefined"){
    $("[name='id']").val(selection.id);
  }
})

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}